(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["divine-logo-mark"] && !Shopify.designMode) return;
  try {
    class DivineLogoMark extends HTMLElement {
    #observer = null;

    connectedCallback() {
      if (!this.classList.contains('divine-mark--animated') || !('IntersectionObserver' in window)) return;
      // Leaps only while the mark is on screen; off screen it rests.
      this.#observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) this.classList.toggle('divine-mark--play', entry.isIntersecting);
        },
        { threshold: 0.6 }
      );
      this.#observer.observe(this);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }
  }

  if (!customElements.get('divine-logo-mark')) customElements.define('divine-logo-mark', DivineLogoMark);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["divine-mobile-menu"] && !Shopify.designMode) return;
  try {
    class DivineMobileMenu extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('dialog');
      if (!this.panel) return;

      this.querySelector('[data-open]')?.addEventListener('click', () => this.panel.showModal());
      this.querySelector('[data-close]')?.addEventListener('click', () => this.panel.close());

      // Following a link closes the panel so "back" returns to a clean page.
      this.panel.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.panel.close();
      });
    }
  }

  if (!customElements.get('divine-mobile-menu')) {
    customElements.define('divine-mobile-menu', DivineMobileMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["divine-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    const WAIT = 'divine-reveal--wait';
    const DONE = 'divine-reveal--done';
    const ORDER = '--divine-reveal-order';
    /** How long a unit may hold for its photos before it shows anyway (ms). */
    const PHOTO_PATIENCE = 700;

    const root = document.documentElement;
    const selector = document.querySelector('meta[name="divine-reveal-units"]')?.getAttribute('content');
    if (!root.classList.contains('divine-reveal-on') || !selector) return;

    /** @type {Set<HTMLElement>} units still waiting below the screen */
    const waiting = new Set();
    let revealer = null;
    let preloader = null;

    /**
     * Marks the unit as finished so it keeps only its own styles.
     * @param {HTMLElement} unit
     */
    const finish = (unit) => {
      unit.classList.add(DONE);
      unit.style.removeProperty(ORDER);
    };

    /**
     * Shows a waiting unit at once, without the movement (used for units the viewer flicked past).
     * @param {HTMLElement} unit
     */
    const showNow = (unit) => {
      waiting.delete(unit);
      revealer?.unobserve(unit);
      finish(unit);
      unit.classList.remove(WAIT);
    };

    /**
     * Resolves once every photo inside the unit is decoded, or after a short patience, so the
     * picture and its text arrive together without ever holding the page.
     * @param {HTMLElement} unit
     * @returns {Promise<void>}
     */
    const photosReady = (unit) => {
      const pending = [...unit.querySelectorAll('img')].filter((img) => !img.complete);
      if (pending.length === 0) return Promise.resolve();
      const decoded = Promise.allSettled(pending.map((img) => img.decode()));
      const patience = new Promise((resolve) => setTimeout(resolve, PHOTO_PATIENCE));
      return Promise.race([decoded, patience]).then(() => undefined);
    };

    /**
     * Starts the movement for a unit that has entered the screen.
     * @param {HTMLElement} unit
     * @param {number} order position among the units entering together (stagger)
     */
    const reveal = (unit, order) => {
      waiting.delete(unit);
      revealer?.unobserve(unit);
      photosReady(unit).then(() => {
        unit.style.setProperty(ORDER, String(order));
        unit.classList.remove(WAIT);
      });
    };

    /** @param {IntersectionObserverEntry[]} entries */
    const onEnter = (entries) => {
      let order = 0;
      for (const entry of entries) {
        const unit = entry.target;
        if (!(unit instanceof HTMLElement) || !entry.isIntersecting || !waiting.has(unit)) continue;
        reveal(unit, order);
        order += 1;
      }
      // A fast flick can carry a unit through the screen between two observer reports.
      for (const unit of waiting) {
        if (unit.getBoundingClientRect().bottom < 0) showNow(unit);
      }
      if (waiting.size === 0) {
        revealer?.disconnect();
        preloader?.disconnect();
      }
    };

    /** Asks the lazy photos of units one screen ahead to load now. */
    const onApproach = (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        for (const img of entry.target.querySelectorAll('img[loading="lazy"]')) img.loading = 'eager';
        preloader?.unobserve(entry.target);
      }
    };

    const start = () => {
      const units = [...document.querySelectorAll(selector)].filter((unit) => unit instanceof HTMLElement);
      if (units.length === 0) return;

      const fold = window.innerHeight;
      for (const unit of units) {
        unit.addEventListener('animationend', (event) => {
          if (event.target === unit && event.animationName === 'divine-reveal') finish(unit);
        });
        if (unit.getBoundingClientRect().top >= fold) {
          // Below the first screen: waits for its turn.
          unit.classList.add(WAIT);
          waiting.add(unit);
        } else if (!(unit.getAnimations ? unit.getAnimations() : []).some((animation) => animation.animationName === 'divine-reveal')) {
          // On the first screen and its opening movement is already over (or it is not shown at all).
          finish(unit);
        }
      }
      if (waiting.size === 0) return;

      revealer = new IntersectionObserver(onEnter, { rootMargin: '0px 0px -48px 0px' });
      preloader = new IntersectionObserver(onApproach, { rootMargin: '100% 0px 100% 0px' });
      for (const unit of waiting) {
        revealer.observe(unit);
        preloader.observe(unit);
      }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["divine-validation"] && !Shopify.designMode) return;
  try {
    class DivineValidation extends HTMLElement {
    #onInvalid = (event) => {
      const field = event.target;
      if (!this.#isField(field) || !field.closest('.divine-section')) return;
      field.setCustomValidity('');
      const message = this.#message(field);
      if (message) field.setCustomValidity(message);
    };

    #onInput = (event) => {
      if (this.#isField(event.target)) event.target.setCustomValidity('');
    };

    connectedCallback() {
      document.addEventListener('invalid', this.#onInvalid, true);
      document.addEventListener('input', this.#onInput, true);
      document.addEventListener('change', this.#onInput, true);
    }

    disconnectedCallback() {
      document.removeEventListener('invalid', this.#onInvalid, true);
      document.removeEventListener('input', this.#onInput, true);
      document.removeEventListener('change', this.#onInput, true);
    }

    /**
     * @param {EventTarget | null} field
     * @returns {field is HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement}
     */
    #isField(field) {
      return field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement;
    }

    /**
     * @param {HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement} field
     * @returns {string}
     */
    #message(field) {
      const state = field.validity;
      const texts = this.dataset;
      if (state.valueMissing) return (field instanceof HTMLSelectElement ? texts.choose : texts.required) || '';
      if (state.typeMismatch && field.type === 'email') return texts.email || '';
      if (field instanceof HTMLInputElement) {
        if (state.rangeUnderflow) return (texts.min || '').replace('[min]', field.min);
        if (state.rangeOverflow) return (texts.max || '').replace('[max]', field.max);
        if (state.stepMismatch || state.badInput) return texts.number || '';
      }
      return '';
    }
  }

  if (!customElements.get('divine-validation')) customElements.define('divine-validation', DivineValidation);
  } catch(e) { console.error(e); }
})();

})();
